export default {
  computed: {
    data () {
      return Object.keys(this.form)
        .map((key) => `${key}=${encodeURIComponent(this.form[key])}`)
        .join('&')
    }
  }

}
